<template>
  <div>
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>

export default {
  name: 'ProductContainer',
  beforeMount() {
    if (this.$route.name === 'ProductContainer') {
      this.$router.replace({name: 'Products' });
    }
  }
}
</script>
